import moment from 'moment';
import { database, fieldValue } from './firebase';

const rootCollection = 'forums';
const rootDoc = 'general';
const baseTopic = 'topics';
const forumRef = database.collection(rootCollection).doc(rootDoc);
const topicRef = forumRef.collection(baseTopic);
interface IFetchTopicOptions {
  action?: 'next' | 'previous';
  limit: number;
  lastVisible?: firebase.default.firestore.DocumentData;
}
export const convertTopicDiscussion = (
  data: firebase.default.firestore.DocumentData
): ITopicDiscussion => {
  return {
    author: data.author,
    avatar: data.avatar,
    commentCount: data.commentCount,
    content: data.content,
    createdAt: moment(data.createdAt.toDate()),
    title: data.title,
    uid: data.uid,
    docId: data.ref.id,
  };
};
export const fetchTopics = async (
  options: IFetchTopicOptions
): Promise<
  [firebase.default.firestore.DocumentData[], boolean] | undefined
> => {
  const { action, lastVisible, limit } = options;
  try {
    let ref = topicRef.orderBy('createdAt', 'desc');
    const isForward = !action || action === 'next';
    if (isForward) {
      ref = lastVisible ? ref.startAfter(lastVisible) : ref;
      ref = ref.limit(limit + 1);
    } else {
      ref = lastVisible ? ref.endBefore(lastVisible) : ref;
      ref = ref.limitToLast(limit + 1);
    }
    const snapshot = await ref.get();
    const hasOtherPage = limit < snapshot.docs.length;
    let docs = snapshot.docs;
    if (hasOtherPage) {
      docs = isForward
        ? docs.filter((_, i) => i !== docs.length - 1)
        : docs.filter((_, i) => i);
    }
    const values = docs.map((doc) => ({ ...doc.data(), ref: doc }));
    return [values, hasOtherPage];
  } catch (error) {
    console.log(error);
    return undefined;
  }
};

export const createTopic = async (
  data: ITopicDiscussion
): Promise<ITopicDiscussion | undefined> => {
  try {
    await Promise.all([
      topicRef.doc().set({ ...data, createdAt: fieldValue.serverTimestamp() }),
      database
        .collection(rootCollection)
        .doc(rootDoc)
        .set({ count: fieldValue.increment(1) }, { merge: true }),
    ]);
    const doc = await topicRef.doc().get();
    const result = doc.data() as ITopicDiscussion;
    return result;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export { forumRef, topicRef };
